// extracted by mini-css-extract-plugin
export default {"TableBody":"rdlc_TableBody__+rT0j"};